const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../views/self_service_actions/single_action_ssa')
const {Portal} = require('preact-portal');
const Web2018Helper = require("../../../helper")

class TradeInVoucherSSA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.isTradeInStarted = this.isTradeInStarted.bind(this);
    this.getTradeInVoucherUrl = this.getTradeInVoucherUrl.bind(this);
    this.getSingleVoucherSSA = this.getSingleVoucherSSA.bind(this);
    this.getSSATable = this.getSSATable.bind(this);
  }

  openPopup(event){
    this.setState({open: true});
  }

  closePopup(event){
    this.setState({open: false});
  }

  isTradeInStarted(groupon){
    return (lodash.has(groupon, 'redemptionPolicy.tradeIn.status')&&(["pending","in_progress"].indexOf(groupon.redemptionPolicy.tradeIn.status) > -1))
  }

  getTradeInVoucherUrl(grouponId){
    if(Web2018Helper.isFeatureFlagEnabled("enableTradeInExtension"))
      return `/users/${ this.props.userUUID }/groupons/vouchers/${ grouponId }?show_tradein=true&editable_types=cs_extended_trade_in&source=customer_support`;
    else
      return `/users/${ this.props.userUUID }/groupons/vouchers/${ grouponId }?show_tradein=true&source=customer_support`;
  }

  getSingleVoucherSSA(){
    let SSADetails = {
      SSAText: I18n.translate("js.modules.support.trade_in_voucher"),
      UrlForSSA: this.getTradeInVoucherUrl(this.props.orderDetails.groupons[0].id),
      SSASubText: I18n.translate("js.modules.support.trade_in_voucher_subtext")
    }
    return (
      <SingleActionSSAView  orderDetails = {this.props.orderDetails} firstSSA = {this.props.firstSSA} landingView = {this.props.landingView} SSADetails = {SSADetails} />
    );
  }

  getSSATable(){
    let SSAList = [];
    let index = 1;

    this.props.orderDetails.groupons.forEach(groupon => {
      let voucherAction;
      if(this.props.isGrouponRedeemed(groupon)){
        voucherAction = I18n.translate("js.modules.support.Redeemed")
      }
      else if(this.props.isGrouponRefunded(groupon)){
        voucherAction = I18n.translate("js.modules.support.refunded")
      }
      else if(this.isTradeInStarted(groupon)){
        voucherAction = I18n.translate("js.modules.support.trade_in_started")
      }
      else{
        voucherAction = (
          <a href={this.getTradeInVoucherUrl(groupon.id)} class="btn ssa-button"
             rel="noopener noreferrer" target="_blank"
             data-bhw={"web2018_trade_in_voucher_button_inside_popup" + "__"+ this.props.orderDetails.id}>
            {I18n.translate("js.modules.support.trade_in_voucher")}
          </a>);
      }
      SSAList.push(
        <tr>
          <td>
            {index++}.&nbsp;
            <a href={this.props.elementsForPopup.dealUrl}
               rel="noopener noreferrer" target="_blank"
               data-bhw={"web2018_deal_link_in_trade_in_voucher_popup"+"__"+ this.props.orderDetails.id}>
              {this.props.elementsForPopup.dealTitle}
            </a>
          </td>
          <td>
            {voucherAction}
          </td>
        </tr>
      );
    });
    return (<table class="ssa-deal-sub-table"> {SSAList} </table>);
  }

  getClassName() {
    if (this.props.landingView){
      return "ssa-holder-landing multi-voucher-ssa"
    }
    else {
      return "ssa-holder multi-voucher-ssa"
    }
  }
  getClassNameButton(){
    if (this.props.landingView){
      return "multiple-voucher-class"
    }
    else {
      return "ssa-button btn-invert"
    }
  }

  getMultipleVoucherSSA(){
    var seperator = ""

    if (!this.props.firstSSA && this.props.landingView) {
      seperator = "| "
    }

    return(
      <div class={this.getClassName()}>
          <span>{seperator}</span>
          <span class={this.getClassNameButton()} data-bhw={"web2018_trade_in_multiple_vouchers_button"+ "__"+ this.props.orderDetails.id} onClick={this.openPopup}>
            {I18n.translate("js.modules.support.trade_in_vouchers")}
            {!(this.props.landingView) && <div class="ssa-subtext">{I18n.translate("js.modules.support.trade_in_voucher_subtext")}</div>}
          </span>
          { this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_trade_in_multiple_vouchers_popup">
                <div>
                  <span class="icon-x" onClick={this.closePopup} data-bhw="web2018_trade_in_multiple_vouchers_close_button"></span>
                </div>
                <div class="ssa-link-title">
                {I18n.translate("js.modules.support.trade_in_vouchers")}
                </div>
                <div class="ssa-description" dangerouslySetInnerHTML={{ __html: I18n.translate("js.modules.web_2018.trade_in_description")}}/>
                <table class="ssa-main-table">
                  <tr>
                    <td class="ssa-deal-image-cell">
                      <img class="ssa-deal-image" src={this.props.elementsForPopup.image} alt="Deal Image"/>
                    </td>
                    <td class="ssa-deal-info-cell">
                      {this.props.elementsForPopup.merchantName} <br/>
                      {I18n.translate("js.modules.support.pur")}&nbsp;{this.props.elementsForPopup.purchaseDate}
                    </td>
                    <td class="ssa-deal-sub-table-cell">
                      {this.getSSATable()}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="shadow"></div>
            </Portal>
            )
          }
        </div>
    );
  }

  constructTradeInVoucherSSA(){
    if (this.props.isSingleGrouponPresent){
      return this.getSingleVoucherSSA()
    }
    else
      return this.getMultipleVoucherSSA();
  }

  render() {
    return this.constructTradeInVoucherSSA();
  }
}
module.exports = TradeInVoucherSSA
